import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import RowsIcon from "../../../../media/images/icons/rows-icons";

import TenderOfferCard from "./TenderOfferCard";
import { blueGrey } from "@mui/material/colors";
import { useAppDispatch } from "../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import { DotLoader } from "react-spinner-overlay";
import EmptyCargoSVG from "../../../../media/images/icons/empty-cargo";
import EmptyListBox from "../../../components/EmptyListBox";
import LoadingBox from "../../../components/LoadingBox";

export interface ITenderOffer {
  handleDeleteTender: (id: string) => void;
  handleEditPrice: (id: string, price: any) => void;
  id: "66d1860b94a6cf41c8ac11c2";
  insertDate: "2024-08-30T08:42:51.912Z";
  updateDate: "2024-08-30T08:42:51.912Z";
  orderId: "66d1851494a6cf41c8ac11bc";
  srcCode: 11320000;
  srcName: "تهران";
  destCode: 67000000;
  destName: "استان زنجان";
  goodsCode: 1861400;
  goodsName: "انواع کشمش";
  companyCode: "1100111";
  orderCode: 210242324000;
  price: 70000000;
  queueNr: 7;
  licenseNr: null;
  status: 1;
  driverFullName: "رضا خورشا";
  driverNationalCode: "3091230155";
  fare: 17000000;
}

export default function () {
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const [tendersList, setTendersList] = useState<ITenderOffer[]>([]);

  const { trigger: getTenderOfferList, isMutating: isgetTenderOfferMutting } =
    useSWRMutation(
      [`/DriverPriceReq/Search`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setTendersList(data.data);
        },
      }
    );

  useEffect(() => {
    getTenderOfferList({});
  }, []);

  const handleDeleteTender = (id: string) => {
    setTendersList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleEditPrice = (id: string, price: any) => {
    setTendersList((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            price,
          };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            مناقصه بار{" "}
          </Typography>
        }
      />

      <Box
        sx={{
          height: "100%",
          paddingX: "8px",
          paddingY: "8px",
          paddingBottom: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            backgroundColor: "bgColor.white",
            padding: "16px",
            border: "1px solid",
            borderColor: blueGrey[100],
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <RowsIcon color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "18px",
              }}
            >
              پیشنهادات مناقصات بار{" "}
            </Typography>
          </Box>
          {/* <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          /> */}
        </Box>
        {/* <FilterSection /> */}

        {/* <CustomInput
          placHolder="جستجو بر اساس نام محموله..."
          endAdornment={<SearchSVG color={theme.palette.primary.main} />}
        /> */}

        {isgetTenderOfferMutting ? (
          <LoadingBox />
        ) : tendersList.length ? (
          tendersList.map((item: ITenderOffer) => (
            <TenderOfferCard
              key={item.id}
              {...item}
              handleDeleteTender={handleDeleteTender}
              handleEditPrice={handleEditPrice}
            />
          ))
        ) : (
          <EmptyListBox description="درحال حاضر مناقصه‌ای ثبت نشده است!" />
        )}
      </Box>
    </>
  );
}
